// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"94043007","977":"7f755390"}[chunkId] + ".chunk.js";
};